import { Form, Segment, Input, Checkbox } from "semantic-ui-react";
import startCase from "lodash/startCase";

import RuvixxSelect from "components/RuvixxSelect";
import { questionTypes } from "constants/Question";
import ContactService from "services/Contact";

import styles from "./FollowupQuestion.module.scss";

const OPTION_TYPES = [
  questionTypes.dropdown,
  questionTypes.checkboxGroup,
  questionTypes.radioButtonGroup,
];

/**
 * Single follow-up question editor. It stays on Semantic UI because it renders
 * inside Semantic modals (the follow-up and form-response modals), which sit
 * above every shadcn popup layer.
 */
const FollowupQuestion = ({ question, onUpdate, onEditOptions }) => {
  const { title, question_type, options, required, roles } = question;

  // Sections only group questions on a multi-page form, and a follow-up
  // cannot collect uploads.
  const questionTypesOptions = Object.entries(questionTypes)
    .filter(([key]) => key !== "section")
    .filter(([key]) => !(question.parent_question_id && key === "upload"))
    .map(([key, value]) => ({ key: value, text: startCase(key), value }));

  const handleChange = data => {
    const { name, type } = data;
    const value = data[type === "checkbox" ? "checked" : "value"];
    onUpdate({ ...question, [name]: value });
  };

  return (
    <Segment className={styles.question}>
      <Form.Field required>
        <label>Question</label>
        <Input
          name="title"
          value={title || ""}
          onChange={(_, data) => handleChange(data)}
        />
      </Form.Field>
      {question_type !== questionTypes.section && (
        <Form.Field inline>
          <label>
            Required <span className="requiredStar" />
          </label>
          <Checkbox
            toggle
            name="required"
            checked={required}
            onChange={(_, data) => handleChange(data)}
          />
        </Form.Field>
      )}
      <Form.Select
        selectOnBlur={false}
        inline
        label="Type"
        name="question_type"
        required
        options={questionTypesOptions}
        value={question_type}
        onChange={(_, data) => handleChange(data)}
      />
      {!question.parent_question_id &&
        question_type !== questionTypes.section && (
          <RuvixxSelect
            name="roles"
            label="Roles"
            value={roles}
            queryFn={ContactService.getAvailableRoles}
            clearable
            onChange={(_, data) => handleChange(data)}
            multiple
            lazy
          />
        )}
      {OPTION_TYPES.includes(question_type) && (
        <Form.Field required inline className="options">
          <label>Options</label>
          <div onClick={() => onEditOptions(question, onUpdate)}>
            {options.length > 0
              ? options.map(({ label }) => label).join(", ")
              : "(No options. Click to add.)"}
          </div>
        </Form.Field>
      )}
    </Segment>
  );
};

export default FollowupQuestion;
